import { render, staticRenderFns } from "./VendutoList.vue?vue&type=template&id=531cd3a9"
import script from "./VendutoList.vue?vue&type=script&lang=ts"
export * from "./VendutoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531cd3a9')) {
      api.createRecord('531cd3a9', component.options)
    } else {
      api.reload('531cd3a9', component.options)
    }
    module.hot.accept("./VendutoList.vue?vue&type=template&id=531cd3a9", function () {
      api.rerender('531cd3a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VendutoList.vue"
export default component.exports